<template>
  <div class="list-page">
    <div class="list-card">
      <div class="list-header">
        <div class="list-selectors">
          <select v-model="selectedYear" class="form-control form-control-sm">
            <option v-for="(year, index) in years" :key="index" :value="year">{{ year }}年</option>
          </select>
          <select v-model="selectedMonth" class="form-control form-control-sm">
            <option v-for="(month, index) in months" :key="index" :value="month">{{ month }}月</option>
          </select>
        </div>
        <button class="view-toggle-btn" @click="isCalendarDisplay = !isCalendarDisplay">
          <i :class="isCalendarDisplay ? 'fas fa-list' : 'fas fa-calendar-alt'"></i>
        </button>
      </div>
      <TimecardCalendar :isCalendarDisplay="isCalendarDisplay" :year="selectedYear" :month="selectedMonth - 1" :hasPaidLeave="data.paid_leave"></TimecardCalendar>
    </div>
  </div>
</template>

<script>
import TimecardCalendar from '../../components/TimecardCalendar.vue';

export default {
  data () {
    return {
      isCalendarDisplay: true,
      years: [],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      selectedYear: this.$moment().year(),
      selectedMonth: this.$moment().month() + 1,
      data: [],
    }
  },
  components: { TimecardCalendar },
  beforeMount() {
    const currentYear = this.$moment().year();
    for (let i = 0; i <= 10; i++) {
      this.years.push(currentYear - i);
    }
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo () {
      this.$http.get(process.env.VUE_APP_API_PATH + '/staff/shop/0/me')
      .then(response => {
        if (response.data.success) {
          this.data = response.data.data.staff;
        }
      })
      .catch(error => {
        if (error.response) {
          this.$toast.error(error.response.data.message);
        }
      });
    },
  },
}
</script>

<style scoped>
.list-page {
  display: flex;
  justify-content: center;
}

.list-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  padding: 20px;
  width: 100%;
  max-width: 560px;
}

.list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.list-selectors {
  display: flex;
  gap: 8px;
}

.list-selectors select {
  width: auto;
  min-width: 100px;
  font-size: 15px !important;
  font-weight: 600;
  border-radius: 8px;
  border: 1.5px solid #d2d6dc;
  padding: 6px 28px 6px 10px;
  -webkit-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23718096' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  height: auto;
  background: #fff;
}

.view-toggle-btn {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  border: none;
  background: #049C4C;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.view-toggle-btn:hover {
  background: #038a42;
}
</style>
